import { Button } from "baseui/button";

const LoadNextPageButton: React.FC<{
  hasMore: boolean;
  isFetching: boolean;
  page: number;
  total: number;
  setPage: (page: number) => void;
}> = ({ hasMore, isFetching, page, setPage, total }) => {
  if (!hasMore) return <></>;
  return (
    <Button
      isLoading={isFetching}
      size="compact"
      kind="secondary"
      onClick={() => setPage(page + 1)}
      title={`total ${total} items`}>
      load more ...
    </Button>
  );
};

export default LoadNextPageButton;
